import { createContext } from 'react';

/**
 * Whether the custom pack lab is what the page previews: a custom pack, or the lab demo, is picked. The page sets it
 * around the sidebar, so the lab's group is listed before the preview has said which page it is on; the group also
 * lists itself once the preview reports the lab. Unset, the sidebar lists the groups every theme editor has always had.
 * A module of its own: the player's iframe imports this package for its theme registry, and a bundle that never
 * renders the editor must not have to keep the editor's file for this one call.
 */
export const LabActiveContext = createContext(false);
